// extracted by mini-css-extract-plugin
export default {"participantList":"styles__participantList___T5woa"};